<!--
 * @Auther: 罗耀祖
 * @Date: 2022-04-24 17:35:21
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-08-11 15:01:36
 * @name: 选择产品
 * @Description: 选择产品
 * @FilePath: \project\src\components\afterSale\product-choose.vue
 * @Author: desktop
-->
<template>
  <el-dialog title="选择产品" width="650px" :visible.sync="show" @close="close">
    <div class="search">
      <el-input
        size="mini"
        v-model="keyword"
        placeholder="请输入关键字..."
      ></el-input>
      <el-button size="mini" type="primary" @click="search">搜索</el-button>
    </div>
    <div class="list">
      <div class="item" v-for="item of list" :key="item.product_id" @click="choose(item)">
        <div class="rows">
          <div class="row">
            <div class="row-label">产品名称：</div>
            <div class="row-value">{{ item.name }}</div>
          </div>
          <div class="row">
            <div class="row-label">型号、颜色：</div>
            <div class="row-value">{{ item.model }}、{{ item.color }}</div>
          </div>
          <div class="row">
            <div class="row-label">品牌：</div>
            <div class="row-value">{{ item.brand }}</div>
          </div>
        </div>
        <img
          src="@/assets/icon/arrow-left-red.png"
          mode="widthFix"
          class="arrow"
        />
      </div>
    </div>
  </el-dialog>
</template>
<script>
import issueService from "@/module/issue/issue.service";
import { Loading } from "element-ui";
import { debounceation } from '@/utils/decorator';
export default {
  data() {
    return {
      issueService: new issueService(),
      show: false,
      keyword: "",
      list: [],
    };
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 打开弹窗
     */
    open(keyword) {
      this.keyword = keyword;
      this.show = true;
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 弹窗关闭回调
     */
    close() {
      this.show = false;
    },
    search() {
      const loading = Loading.service({ text: "加载产品中" });
      this.issueService
        .getPianoModels({
          piano_model: this.keyword,
        })
        .then((res) => {
          this.list = res.data;
        })
        .finally(() => {
          loading.close();
        });
    },
    @debounceation(300)
    choose(item) {
      this.$emit("choose", item);
    },
  },
};
</script>
<style lang="scss" scoped>
.search {
  width: 100%;
  @extend .et-flex-start;
  .el-button {
    margin-left: 10px;
  }
}
.list {
  margin-top: 20px;
  width: 100%;
  height: 400px;
  overflow-y: auto;
  @extend .et-flex-column-center;
  .item {
    width: 100%;
    padding: 10px 15px;
    border-bottom: 1px solid $Vars-border-second-color;
    box-sizing: border-box;
    @extend .et-flex-start;
    @extend .et-clickElement;
    .rows {
      flex: 1;
      .row {
        width: 100%;
        line-height: $Vars-font-normal-lineHeight;
        @extend .et-flex-normal;
      }
    }
    .arrow {
      width: 10px;
      transform: rotate(180deg);
      margin: 0 5px;
    }
  }
}
</style>